import { Action, AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { IconName } from 'components/atoms/Icon/all';
import { RootState } from '../reducers';

export type Dispatch = ThunkDispatch<RootState, any, AnyAction>;
export type GetState = () => RootState;
export type SelectOption<Value = any> = { label: string; value: Value };
export type GroupedSelectOption<T = Record<string, any>> = {
  label: string;
  options: T;
};

export interface ToggleSelectOption<Value = any> extends SelectOption<Value> {
  icon?: IconName;
}
export type AppThunk<ReturnType = any> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
export type AppThunkP<ReturnType = any> = ThunkAction<Promise<ReturnType>, RootState, unknown, Action<string>>;

export type ButtonStyleType =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'destruction'
  | 'transparent'
  | 'white'
  | 'navy'
  | 'black'
  | 'gray-toggle'
  | 'light-gray'
  | 'icon-only';
export type ButtonSize = 'xs' | 'small' | 'small-toggle' | 'no-padding' | 'gloo-medium';
export type TagColor =
  | 'red'
  | 'blue'
  | 'yellow'
  | 'pink'
  | 'green'
  | 'darkGreen'
  | 'greenBorder'
  | 'greenInverted'
  | 'lightRed'
  | 'lightYellow'
  | 'lightPurple'
  | 'lightPurpleInverted'
  | 'transparentBlue'
  | 'gray'
  | 'glooCharcoal'
  | 'clearBlue'
  | 'lightNavy'
  | 'darkNavy'
  | 'white'
  | 'default'
  | 'lightGray'
  | 'inactive';
export type NullStateType =
  | 'prayer'
  | 'stories'
  | 'users'
  | 'explorerConnections'
  | 'series'
  | 'scheduledMessages'
  | 'scheduledMessagesDashboard'
  | 'actions'
  | 'userPrayer'
  | 'userStories'
  | 'userDevotionals'
  | 'noData'
  | 'subscribers'
  | 'devoMessages'
  | 'devoOnlyImmediateMessage'
  | 'userActions'
  | 'userActivity'
  | 'messageViewer'
  | 'messageSelect'
  | 'groups'
  | 'tags'
  | 'surveys'
  | 'discover'
  | 'inProgressChallengesList'
  | 'completedChallengesList'
  | 'messageViewerNotVerifiedExplorers'
  | 'messageViewerNotVerifiedAttendees'
  | 'inProgressChallenges'
  | 'completedChallenges'
  | 'completedChallengesHome'
  | 'noSelectedChallengeHome'
  | 'notFound'
  | 'products'
  | 'favoritedKits'
  | 'discoverSwimlane'
  | 'conversationPrompts'
  | 'adminConversationPrompts';

export type TextReplacer = { text: string; replacer: string };

export enum TailwindBreakpoint {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = '2xl',
}
